module.exports = __webpack_public_path__ + "media/Audio16_c.ad48ccbd.wav";